// extracted by mini-css-extract-plugin
export default {"webRegisteringContainer":"WebRegistering_webRegisteringContainer__snIZ0","buttonWrapper":"WebRegistering_buttonWrapper__QEbye","ReturnToTop":"WebRegistering_ReturnToTop__YVZsm"};